var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBack = function SvgBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6H3.135L6.768,1.64A1,1,0,0,0,5.232.36l-5,6a.942.942,0,0,0-.088.154.947.947,0,0,0-.071.124A.985.985,0,0,0,0,7V7S0,7,0,7a.985.985,0,0,0,.072.358.947.947,0,0,0,.071.124.942.942,0,0,0,.088.154l5,6a1,1,0,0,0,1.536-1.28L3.135,8H15a1,1,0,0,0,0-2",
    transform: "translate(4 5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6H3.135L6.768,1.64A1,1,0,0,0,5.232.36l-5,6a.942.942,0,0,0-.088.154.947.947,0,0,0-.071.124A.985.985,0,0,0,0,7V7S0,7,0,7a.985.985,0,0,0,.072.358.947.947,0,0,0,.071.124.942.942,0,0,0,.088.154l5,6a1,1,0,0,0,1.536-1.28L3.135,8H15a1,1,0,0,0,0-2",
    transform: "translate(4 5)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back.8984a980.svg";
export { ForwardRef as ReactComponent };